<template>
    <div>
        <div class="tit-wrap">
            <h3 class="tit top-line-tit">KOREA</h3>
        </div>

        <v-data-table
            :headers="headers"
            :items="items"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            mobile-breakpoint="0"
            @page-count="pageCount = $event"
            class="v-data-table--default v-data-table--no-active"
        ></v-data-table>

        <div class="v-pagination-wrap text-center">
            <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                { text: "P/J Name", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "Client", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "End-User", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "Year", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "Description", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [
                {
                    name: "#1,2 WWT TOC, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2022",
                    description: "TOC Analyzer",
                },
                {
                    name: "#2 ALK Revamping, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "Moisture Analyzer, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2022",
                    description: "Moisture Analyzer",
                },
                {
                    name: "P4 Project, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2022",
                    description: "GC Analyzer with Shelter",
                },
                {
                    name: "HPC P Project, Korea",
                    client: "Hanwha Solution",
                    user: "Hanwha Solution",
                    year: "2022",
                    description: "pH Analyzer",
                },
                {
                    name: "D-LNC Project, Korea",
                    client: "KAS",
                    user: "Lotte Chemical",
                    year: "2022",
                    description: "Analyzer Shelter",
                },
                {
                    name: "KPC O2 Project, Korea",
                    client: "KPC",
                    user: "KPC",
                    year: "2022",
                    description: "O2 Analyzer (TDL)",
                },
                {
                    name: "Wobbe Index Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2022",
                    description: "Wobbe Index Analyzer",
                },
                {
                    name: "HBr Project, Korea",
                    client: "SK Showadenko",
                    user: "SK Showadenko",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "LG Chemical RTO in Yeosu, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2021",
                    description: "FID Analyzer (HC)",
                },
                {
                    name: "SOEC Pilot Project, Korea",
                    client: "SKEC",
                    user: "Bloom SK Fuel Cell",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "Requisition for Density Analyzer, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2021",
                    description: "Density Analyzer",
                },
                {
                    name: "MTBE Project, Korea",
                    client: "HEC",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer Package",
                },
                {
                    name: "Yeosu PVC, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2020",
                    description: "O2 Analyzer",
                },
                {
                    name: "Yeosu IPA, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2020",
                    description: "O2 Analyzer",
                },
                {
                    name: "GS Caltex MRO in Yeosu, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2020",
                    description: "TOC Analyzer Shelter",
                },
                {
                    name: "HPC Project, Korea",
                    client: "Daelim",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-3",
                },
                {
                    name: "HPC Project, Korea",
                    client: "Lotte E&C",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-2",
                },
                {
                    name: "HPC Project, Korea",
                    client: "HEC",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-1",
                },
                {
                    name: "HYCO Project, Korea",
                    client: "HSC",
                    user: "HENC",
                    year: "2020",
                    description: "Analyzer with Shelter",
                },
                {
                    name: "Revamping Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2020",
                    description: "Analyzer Revampling",
                },
                {
                    name: "OA Revamping Project, Korea",
                    client: "HENC",
                    user: "HCC",
                    year: "2020",
                    description: "Conductivity Analyzer",
                },
                {
                    name: "WAO Project, Korea",
                    client: "HPC",
                    user: "SCT",
                    year: "2020",
                    description: "OIW Analyzer",
                },
                {
                    name: "Ulsan PP Project, Korea",
                    client: "UPP",
                    user: "SKEC",
                    year: "2019",
                    description: "Analyzer Package",
                },
                {
                    name: "S Project, Korea",
                    client: "SKE",
                    user: "SKEC",
                    year: "2019",
                    description: "Oil Leak Detector",
                },
                {
                    name: "Ulsan NOC Project, Korea",
                    client: "SKEC",
                    user: "NOC",
                    year: "2019",
                    description: "OIW Analyzer",
                },
                {
                    name: "#1 NHT, Korea",
                    client: "SKEC",
                    user: "SKIPC",
                    year: "2019",
                    description: "Local Field Analyzer",
                },
                {
                    name: "S Project(NAC Utility), Korea",
                    client: "SKE",
                    user: "SKEC",
                    year: "2019",
                    description: "Hardness Analyzer",
                },
                {
                    name: "SKIPC Moisture, Korea",
                    client: "SKEC",
                    user: "SKIPC",
                    year: "2019",
                    description: "Moisture Analyzer",
                },
                {
                    name: "Hydrogen Fuel Cell Pilot, Korea",
                    client: "SKEC",
                    user: "SKEC",
                    year: "2019",
                    description: "H2 Analyzer",
                },
                {
                    name: "The Project, Korea",
                    client: "HENC",
                    user: "HCC",
                    year: "2019",
                    description: "NIR Analyzer",
                },
                {
                    name: "S Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2018",
                    description: "Analyzer Package",
                },
                {
                    name: "Merox Reactor Installation Project, Korea",
                    client: "SKIPC",
                    user: "SKIPC",
                    year: "2017",
                    description: "Mercaptan Analyzer with shelter",
                },
                {
                    name: "HDO Revamping Project, Korea",
                    client: "HEC",
                    user: "HDO",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "RUC Project, Korea",
                    client: "DIC",
                    user: "S-Oil",
                    year: "2016",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "RUC Project, Korea",
                    client: "Daewoo E&C",
                    user: "S-Oil",
                    year: "2016",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "YNCC C5 Project, Korea",
                    client: "HENC",
                    user: "YNCC",
                    year: "2015",
                    description: "O2 Analyzer system",
                },
                {
                    name: "Dolphin Project, Korea",
                    client: "eTEC",
                    user: "UMICORE",
                    year: "2013",
                    description: "H2 & O2 Analyzer",
                },
                {
                    name: "V Project, Korea",
                    client: "HDEC",
                    user: "SKI",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "New PX Project, Korea",
                    client: "SKEC",
                    user: "SKI",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Nexlene Project, Korea",
                    client: "SKEC",
                    user: "SKI",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "HBO Project, Korea",
                    client: "SaeHan Hitech",
                    user: "SKE",
                    year: "2012",
                    description: "Pour Point/ Hydrocarbon/ H2 Analyzer",
                },
                {
                    name: "T Project, Korea",
                    client: "eTEC",
                    user: "Nisso Namhae Agro",
                    year: "2012",
                    description: "Moisture Analyzer",
                },
                {
                    name: "CLX Project, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2012",
                    description: "Distillation Analyzer system",
                },
                {
                    name: "3PZ Project, Korea",
                    client: "eTEC",
                    user: "HPC",
                    year: "2012",
                    description: "Analyzer Package",
                },
                {
                    name: "LNG Plant R&D Project, Korea",
                    client: "GS E&C",
                    user: "LNG PLANT R&D CENTER",
                    year: "2012",
                    description: "GC Analyzer",
                },
                {
                    name: "VGOFCC Project, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2012",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "SKGC Project, Korea",
                    client: "SKI",
                    user: "SKGC",
                    year: "2011",
                    description: "HC Analyzer Package",
                },
                {
                    name: "SaeHan_SK H Project, Korea",
                    client: "SaeHan Hitech",
                    user: "SKI",
                    year: "2011",
                    description: "Analyzer Package",
                },
                {
                    name: "Voltaix Korea New Germane Plant Project",
                    client: "Voltaix Korea",
                    user: "Voltaix Korea",
                    year: "2011",
                    description: "Analyzer Package",
                },
                {
                    name: "S-Oil Off-site Automation Project, Korea",
                    client: "ISU E&C",
                    user: "S-Oil",
                    year: "2011",
                    description: "B-C Blending OIW and Viscosity Analyzer",
                },
                {
                    name: "S-Oil Off-site Automation Project, Korea",
                    client: "ISU E&C",
                    user: "S-Oil",
                    year: "2010",
                    description: "B-C Blending Analyzer System with shelter",
                },
                {
                    name: "SK Incheon Micro Dist' Analyzer, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2010",
                    description: "Distillation Analyzer system with shelter",
                },
                {
                    name: "HDO BTX Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2010",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "HDO #2 HOU Project, Korea",
                    client: "HDEC",
                    user: "HDO",
                    year: "2010",
                    description: "TMS Analyzer with shelter",
                },
                {
                    name: "HDO #2 HOU Project, Korea",
                    client: "HDEC",
                    user: "HDO",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "S-Oil Expansion Project, Korea",
                    client: "SECL",
                    user: "S-Oil",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "SDA Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2009",
                    description: "Hydrocarbon Analyzer system",
                },
                {
                    name: "No.3 HOU Project, Korea",
                    client: "GS E&C",
                    user: "GS Caltex",
                    year: "2009",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "HDO MRO Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2009",
                    description: "Flash Point Analyzer & Distillation Analyzer system",
                },
                {
                    name: "KCC P2 Project, Korea",
                    client: "HDEC",
                    user: "KCC",
                    year: "2009",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "No.3 HOU Project, Korea",
                    client: "GS E&C",
                    user: "GS Caltex",
                    year: "2009",
                    description: "Flash Point Analyzer & Distillation Analyzer system",
                },
                {
                    name: "S-Oil Alkylation Project, Korea",
                    client: "HDEC",
                    user: "S-Oil",
                    year: "2009",
                    description: "Field Analyzer Package System with Shelter",
                },
                {
                    name: "S-Oil Alkylation Project, Korea",
                    client: "HDEC",
                    user: "S-Oil",
                    year: "2008",
                    description: "GC Analyzer Package System with Shelter",
                },
                {
                    name: "SKICO New FCC Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2007",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "SKICO New FCC Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2007",
                    description: "HC, CL, COD Analyzer system",
                },
                {
                    name: "Gunjang GO-GEN Project, Korea",
                    client: "HENC",
                    user: "Gunjang Energy Company",
                    year: "2007",
                    description: "CEMS Analyzer package system with shelter",
                },
                {
                    name: "RW Project, Korea",
                    client: "eTEC",
                    user: "OCI",
                    year: "2007",
                    description: "GC, H2,O2, CO, CO2&nbsp;Analyzers Package System",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "H2 Analyzer system",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "Chlorine Analyzer with Local Panel",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "HC Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "Viscosity, Pour, HC Analyzer System",
                },
                {
                    name: "PTT Solvay Onsan K2-Project, Korea",
                    client: "eTEC",
                    user: "PTT Solvay",
                    year: "2006",
                    description: "RVP Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "KES2 Project, Korea",
                    client: "eTEC",
                    user: "Dongwoo Fine-Chem Co.,Ltd.",
                    year: "2006",
                    description: "O2 Analyzer system",
                },
                {
                    name: "#3CDU Project, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2005",
                    description: "Cloud, Pour, Freezing point analyzer system",
                },
                {
                    name: "DCC KN Project, Korea",
                    client: "OCI",
                    user: "OCI",
                    year: "2005",
                    description: "H2 Analyzer system",
                },
                {
                    name: "DCC KT Project, Korea",
                    client: "OCI",
                    user: "OCI",
                    year: "2005",
                    description: "H2, CO, CO2 analyzer system",
                },
                {
                    name: "KES1-Project, Korea",
                    client: "eTEC",
                    user: "Daewoo Precision Industries Co.,Ltd.",
                    year: "2005",
                    description: "O2 Analyzer system",
                },
                {
                    name: "Songwon Industrial Incinerator Project, Korea",
                    client: "Dasan RND Co., Ltd.",
                    user: "Songwon Ind.",
                    year: "2004",
                    description: "CEMS Systems",
                },
                {
                    name: "N Project, Korea",
                    client: "HENC",
                    user: "HENC",
                    year: "2004",
                    description: "CEMS Systems with shelter",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
